var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 6.50047C0.75 6.40102 0.789509 6.30564 0.859835 6.23531C0.930161 6.16498 1.02554 6.12547 1.125 6.12547H9.96975L7.6095 3.76597C7.53908 3.69556 7.49953 3.60006 7.49953 3.50047C7.49953 3.40089 7.53908 3.30539 7.6095 3.23497C7.67991 3.16456 7.77542 3.125 7.875 3.125C7.97458 3.125 8.07009 3.16456 8.1405 3.23497L11.1405 6.23497C11.1754 6.26981 11.2031 6.31119 11.222 6.35675C11.2409 6.40231 11.2507 6.45115 11.2507 6.50047C11.2507 6.5498 11.2409 6.59864 11.222 6.6442C11.2031 6.68976 11.1754 6.73114 11.1405 6.76597L8.1405 9.76597C8.07009 9.83639 7.97458 9.87595 7.875 9.87595C7.77542 9.87595 7.67991 9.83639 7.6095 9.76597C7.53908 9.69556 7.49953 9.60006 7.49953 9.50047C7.49953 9.40089 7.53908 9.30539 7.6095 9.23497L9.96975 6.87547H1.125C1.02554 6.87547 0.930161 6.83596 0.859835 6.76564C0.789509 6.69531 0.75 6.59993 0.75 6.50047V6.50047Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsArrowRight);
export default __webpack_public_path__ + "static/media/bsArrowRight.e7c3cb61650abdc02bdba74c880c4910.svg";
export { ForwardRef as ReactComponent };